import { render, staticRenderFns } from "./ReportTableBody.vue?vue&type=template&id=2dfdd5dc&scoped=true&"
import script from "./ReportTableBody.vue?vue&type=script&lang=ts&"
export * from "./ReportTableBody.vue?vue&type=script&lang=ts&"
import style0 from "./ReportTableBody.vue?vue&type=style&index=0&id=2dfdd5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfdd5dc",
  null
  
)

export default component.exports